import { Component, OnInit } from '@angular/core';
import { ContractorType } from '../contractor-type';
import { ActivatedRoute } from '@angular/router';
import { ContractorTypeService } from '../contractor-type.service';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contractor-type-crud',
  templateUrl: './contractor-type-crud.component.html',
  styleUrls: ['./contractor-type-crud.component.css'],
  providers: [ContractorTypeService]
})
export class ContractorTypeCrudComponent implements OnInit {

  id: any = null;
  contractorTypes: ContractorType;
  msgs: Message[] = [];
  button_caption: string ="Сохранить"
  button_icon:string ="fa fa-save";

  constructor(
              private contractorTypeService: ContractorTypeService,
              private activatedRoute: ActivatedRoute,  
              private router: Router,
              private location: Location
              ) {

  		activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){
   		  	this.contractorTypeService.getContractorTypeById(this.id).subscribe(response=>{this.contractorTypes=response['data']});	
   		 		this.button_caption="Редактировать";
   		 		this.button_icon="fa fa-edit";
   		  }
   }

  ngOnInit() {
  		  	this.contractorTypes={
				id: "",
				name: "",
				code: "", 
				available: true 
  	}
  }

    backClicked() {
        this.location.back();
    }
  
  	crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.contractorTypeService.createContractorType(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data['message']});this.router.navigate(['/contractor-type']);console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});

   		  }else{
   		  	this.contractorTypeService.updateContractorType(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data['message']});console.log(data);}
                  , (error)=>{let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: "+str});console.log(JSON.parse(error._body));});
   		  }



  	}

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/contractor_types/contractor-type-crud/contractor-type-crud.component.ts